import { zetApi } from '@zet/network'
import storage from '@zet/utils/storage'

export const storeToken = async (token: string, action: string) => {
  zetApi.defaults.headers.common = {
    ...zetApi.defaults.headers.common,
    Authorization: `Bearer ${token}`,
    Accept: 'application/json',
    locale: 'en',
  }
  storage.saveObject('SIGNUP_SCREEN_NAME', action)
  storage.saveObject('token', token)
}
